"use client";

import type { InputHTMLAttributes, ReactNode } from "react";

export interface GlassTextFieldProps
	extends InputHTMLAttributes<HTMLInputElement> {
	readonly label: string;
	readonly leading?: ReactNode;
}

/**
 * GlassTextField — single-line text field with a label and optional leading
 * glyph. Mirrors `DSGlassTextField` on iOS.
 */
export function GlassTextField({
	label,
	leading,
	className = "",
	...props
}: Readonly<GlassTextFieldProps>) {
	return (
		<label className={`ds-field ${className}`.trim()}>
			<span className="ds-field__label">{label}</span>
			<span className="ds-field__control">
				{leading === undefined ? null : (
					<span className="ds-field__leading" aria-hidden="true">
						{leading}
					</span>
				)}
				<input aria-label={label} {...props} />
			</span>
		</label>
	);
}
